import axios from 'axios'
import { onSuccess, onError, signbeforeRequestSuccess, beforeRequestError, noAuthBeforeRequestSuccess } from '../interceptors'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'
import { applicationAuthorization } from '@/api/authorization'

const noAuthClient = axios.create({
  baseURL: process.env.USER_API,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    'Authorization': applicationAuthorization(process.env.APPLICATION_KEY)
  }
})

const userClient = axios.create({
  baseURL: process.env.USER_API,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

userClient.interceptors.request.use(signbeforeRequestSuccess, beforeRequestError)
userClient.interceptors.response.use(onSuccess, onError)

noAuthClient.interceptors.request.use(noAuthBeforeRequestSuccess, beforeRequestError)
noAuthClient.interceptors.response.use(onSuccess, (error) => { return onError(error, true) })

export let client = userClient
export let noAuth = noAuthClient



// WEBPACK FOOTER //
// ./src/api/user/client.js